<template>
    <div>
        <b-modal 
            v-model="mostrarModalInabilitarFornecedor" 
            @hidden="fecharModal()" 
            size="md" 
            no-close-on-backdrop
        >
            <div slot="modal-title">Inabilitar Fornecedor</div>

            <b-row v-if="true">
                <b-col>
                    <b-form-group>
                        <label for="nota-tecnica-inabilitacao" class="required">Anexar Nota Técnica</label>
                        <b-form-file
                            id="nota-tecnica-inabilitacao"
                            class="mr-2 flex-grow-1"
                            v-model="arquivoNotaTecnica"
                            ref="selecaoArquivo"
                            placeholder="Selecione o arquivo..."
                            browse-text="Selecione o arquivo"
                            accept=".pdf"
                            @input="validarArquivoNotaTecnica"
                        ></b-form-file>
                        <b-form-invalid-feedback :state="arquivoNotaTecnica && arquivoNotaTecnicaValido">
                            O arquivo deve ter no máximo 10MB.
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button 
                    ref="btnCancelar"
                    class="mr-2"
                    variant="secondary" 
                    @click.stop="fecharModal()" 
                >
                    Cancelar
                </b-button>

                <b-button 
                    ref="btnConfirmar"
                    variant="primary" 
                    :disabled="!arquivoNotaTecnicaValido"
                    @click.stop="confirmarInabilitarFornecedor"
                >
                    Confirmar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import PropostaPrecoServico from '../PropostaPrecoServico';

export default {
    name: 'ModalInabilitarFornecedor',
    props: {
        mostrarModal: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            mostrarModalInabilitarFornecedor: this.mostrarModal,
            arquivoNotaTecnica: null,
            arquivoNotaTecnicaValido: false,
        }
    },
    computed: {
    },
    methods: {
        limparForm(){
            this.arquivoNotaTecnica = null;
            this.arquivoNotaTecnicaValido = false;
        },

        fecharModal() {
            this.mostrarModalInabilitarFornecedor = false;
            this.limparForm();
            this.$emit('update:mostrarModal', this.mostrarModalInabilitarFornecedor);
        },

        validarArquivoNotaTecnica(file) {
            const umMega = 1024 * 1024;
            const maxSize = 10 * umMega;

            this.arquivoNotaTecnicaValido = !!(file && file.size <= maxSize);
        },

        confirmarInabilitarFornecedor() { 
            this.$swal({
                title: 'Confirmação',
                html: `Deseja realmente Inabilitar o fornecedor da proposta de preço?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.inabilitarFornecedor();
                }
            })
        },

        inabilitarFornecedor() {
            const dto = {
                notaTecnica: this.arquivoNotaTecnica
            }

            this.$store.dispatch('addRequest')

            PropostaPrecoServico.InabilitarFornecedor(this.$route.params.propostaPrecoId, dto)
                .then(response => {
                    if (response.success) {
                        this.$toast.success('Fornecedor inabilitado com sucesso', 'Sucesso', this.$toastConfig.success);
                        this.fecharModal();
                        this.$emit('fornecedorInabilitado');
                    } else {
                        this.erros = response.errors || ['Erro ao inabilitar fornecedor'];
                        this.$toast.error(
                            'Erro ao inabilitar fornecedor!',
                            'Erro',
                            this.$toastConfig.error
                        );
                    }
                })
                .catch(error => {
                    console.error('Erro ao inabilitar fornecedor:', error);
                    this.erros = [`Erro ao inabilitar fornecedor: ${error}`];
                    this.$toast.error(
                        'Erro ao inabilitar fornecedor!',
                        'Erro',
                        this.$toastConfig.error
                    );
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                });
        },
    },

    watch: {
        mostrarModal(newVal) {
            this.mostrarModalInabilitarFornecedor = newVal;
        },
    }
}
</script>